import React, {useEffect, useRef} from 'react';
import styled from 'styled-components';

const VideoEl = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
`;

export function AutoPlayVideo({
                                  src,
                                  controls = false,
                                  loop = true,
                                  isActive = false,
                              }: {
    src: string;
    controls?: boolean;
    loop?: boolean;
    isActive?: boolean;
}) {
    const ref = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        if (isActive) {
            const tryPlay = async () => {
                try {
                    await el.play();
                } catch (e) {
                    // ignore autoplay block
                }
            };
            tryPlay();
        } else {
            el.pause();
            try {
                el.currentTime = 0;
            } catch (error) {
                // ignore
            }
        }
    }, [isActive]);

    return (
        <VideoEl
            className={'object-contain'}
            ref={ref}
            src={src}
            muted
            playsInline
            loop={loop}
            autoPlay={false}
            controls={controls}
            preload="metadata"
            crossOrigin="anonymous"
        />
    );
}
